/**
 * LogRocket tracking event names.
 * All custom events sent to LogRocket should be listed in the enum below rather
 * than using a string (if the event name is static).
 */
export var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["TransmitInit"] = "login-transmit-init";
    TrackingEvent["TransmitLoginLoad"] = "login-transmit-login-load";
    TrackingEvent["TransmitLoginSubmit"] = "login-transmit-login-submit";
    TrackingEvent["TransmitSendCodeLoad"] = "login-transmit-send-code-load";
    TrackingEvent["TransmitSendCodeSubmit"] = "login-transmit-send-code-submit";
    TrackingEvent["TransmitVerifyCodeLoad"] = "login-transmit-verify-code-load";
    TrackingEvent["TransmitVerifyCodeSubmit"] = "login-transmit-verify-code-submit";
    TrackingEvent["TransmitAuthenticated"] = "login-transmit-authenticated";
    TrackingEvent["TransmitMobileApproveLoad"] = "login-transmit-mobile-approve-load";
    TrackingEvent["TransmitMobileApproveRepick"] = "login-transmit-mobile-approve-repick";
    TrackingEvent["TransmitMobileApproveResend"] = "login-transmit-mobile-approve-resend";
})(TrackingEvent || (TrackingEvent = {}));
//# sourceMappingURL=constants.js.map